import { Auth, RequestInitImpl } from "./auth";
//import { Promise } from "es6-promise";
import * as fetch from "isomorphic-fetch";

export interface IHttpResult {
  ok: boolean;
  id: string;
  message: string;
}

export default class Fetcher {
  private static mapUrl(url: string): string {
    if (url.substring(0, 3).toLowerCase() === "api") {
      return `/${url}`;
    } else {
      return url;
    }
  }
  static async getAsync<T>(url: string): Promise<T> {
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.headers;
    let data = await (await fetch(url, req)).json();
    return data;
  }
  static get<T>(url: string, success: (d: T) => void, error?: () => void): void {
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.headers;
    fetch(Fetcher.mapUrl(url), req).then((resp: Response): any => {
      if (resp.status >= 400) {
        if (error) {
          error();
        }
      } else {
        return resp.json();
      }
    }).then(function (data: T): void {
      success(data);
    });
  }
  static postSimple<T>(url: string, data: T, cb?: (ok: boolean) => void): void {
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.headers;
    req.method = "POST";
    req.body = JSON.stringify(data);
    fetch(Fetcher.mapUrl(url), req).then((resp: Response): any => {
      cb(resp.ok);
    });
  }
  static post<T>(url: string, data: T, cb?: (resp: string) => void): void {
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.headers;
    req.method = "POST";
    req.body = JSON.stringify(data);
    fetch(Fetcher.mapUrl(url), req).then((resp: Response): any => {
      if (resp.status >= 400) {
        return null;
      } else {
        return resp.text();
      }
    }).then(function (id: string): void {
      if (cb) {
        cb(id || "");
      }
    });
  }
  static postWithData<T>(url: string, data: T, cb?: (result: any) => void, retBodyOnError: boolean = false): void {
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.headers;
    req.method = "POST";
    req.body = JSON.stringify(data);
    fetch(Fetcher.mapUrl(url), req).then((resp: Response): any => {
      if (resp.status >= 400) {
        return retBodyOnError ? resp.json() : null;
      } else if (resp.status === 204) {
        return null;
      } else {
        return resp.json();
      }
    }).then((result: any): void => {
      if (cb) {
        cb(result);
      }
    });
  }
  static postWithResult<T>(url: string, data: T, cb?: (result: IHttpResult) => void): void {
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.headers;
    req.method = "POST";
    req.body = JSON.stringify(data);
    fetch(Fetcher.mapUrl(url), req).then((resp: Response): any => {
      if (resp.status >= 400) {
        return null;
      } else {
        return resp.json();
      }
    }).then((result: IHttpResult): void => {
      if (cb) {
        cb(result);
      }
    });
  }
  static put<T>(url: string, data: T, cb?: (success: boolean) => void): void {
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.headers;
    req.method = "PUT";
    req.body = JSON.stringify(data);
    fetch(Fetcher.mapUrl(url), req).then((resp: Response): void => {
      if (resp.status >= 400) {
        if (cb) {
          cb(false);
        }
      } else {
        if (cb) {
          cb(true);
        }
      }
    });
  }
  static putWithResult<T>(url: string, data: T, cb?: (result: IHttpResult) => void): void {
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.headers;
    req.method = "PUT";
    req.body = JSON.stringify(data);
    fetch(Fetcher.mapUrl(url), req).then((resp: Response): any => {
      if (resp.status >= 400) {
        return null;
      } else {
        return resp.json();
      }
    }).then((result: IHttpResult): void => {
      if (cb) {
        cb(result);
      }
    });
  }
  static putWithData<T>(url: string, data: T, cb?: (result: any) => void, retBodyOnError: boolean = false): void {
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.headers;
    req.method = "PUT";
    req.body = JSON.stringify(data);
    fetch(Fetcher.mapUrl(url), req).then((resp: Response): any => {
      if (resp.status >= 400) {
        return retBodyOnError ? resp.json() : null;
      } else if (resp.status === 204) {
        return null;
      } else {
        return resp.json();
      }
    }).then((result: any): void => {
      if (cb) {
        cb(result);
      }
    });
  }
  static delete(url: string, cb: (s: boolean) => void) {
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.headers;
    req.method = "DELETE";
    fetch(Fetcher.mapUrl(url), req).then((resp: Response): void => {
      if (resp.status >= 400) {
        cb(false);
      } else {
        cb(true);
      }
    });
  }
  static deleteWithResult<T>(url: string, cb?: (result: IHttpResult) => void): void {
      let req: RequestInit = new RequestInitImpl();
      req.headers = Auth.headers;
      req.method = "DELETE";
      fetch(Fetcher.mapUrl(url), req).then((resp: Response): any => {
          if (resp.status >= 400) {
              return null;
          } else {
              return resp.json();
          }
      }).then((result: IHttpResult): void => {
          if (cb) {
              cb(result);
          }
      });
  }
  private static postFile(endpoint: string, files: File[], cb: (resp: string) => void): void {
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.authHeaders;
    req.method = "POST";
    let fd: FormData = new FormData();
    files.map((file: File, i: number): void => {
      fd.append("file-" + i, file);
    });
    req.body = fd;
    fetch(Fetcher.mapUrl(endpoint), req)
      .then((resp: Response): any => {
        if (resp.status === 200) {
          return resp.text();
        } else {
          cb("");
        }
      })
      .then((id: string): void => {
        cb(id);
      });
  }
  static getFileDownload<T>(url: string, cb?: (resp: boolean) => void): void {
    let filename: string = "profile.pdf";
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.headers;
    req.method = "GET";
    fetch(Fetcher.mapUrl(url), req).then((resp: Response): any => {
      if (resp.status === 200) {
        try {
          filename = resp.headers.get("content-disposition").split(";")[1].split("=")[1].replace(/"/g, '');
        } catch (err) { }
        return resp.blob();
      }
    }).then((blob: any): void => {
      let objectUrl: any = URL.createObjectURL(blob);
      let a: any = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display:none";
      a.href = objectUrl;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(objectUrl);
      document.body.removeChild(a);
      cb(true);
      }); 
  }
  static postFileDownload<T>(url: string, data: T, cb?:()=>void): void {
    let filename: string = "profile.pdf";
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.headers;
    req.method = "POST";
    req.body = JSON.stringify(data);
    fetch(Fetcher.mapUrl(url), req).then((resp: Response): any => {
      if (resp.status === 200) {
        try {
          filename = resp.headers.get("content-disposition").split(";")[1].split("=")[1].replace(/"/g, '');
        } catch (err) { }
        return resp.blob();
      }
    }).then((blob: any): void => {
      let objectUrl: any = URL.createObjectURL(blob);
      let a: any = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display:none";
      a.href = objectUrl;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(objectUrl);
      document.body.removeChild(a);
      if (cb) {
        cb();
      }
    });
  }
  static postResume<T>(files: File[], cb: (resp: T) => void): void {
    let req: RequestInit = new RequestInitImpl();
    req.headers = Auth.authHeaders;
    req.method = "POST";
    let fd: FormData = new FormData();
    files.map((file: File, i: number): void => {
      fd.append("file-" + i, file);
    });
    req.body = fd;
    fetch(Fetcher.mapUrl("api/parser/resume"), req)
      .then((resp: Response): any => {
        if (resp.status === 200) {
          return resp.json();
        } 
      })
      .then((results: T): void => {
        cb(results);
      }).catch();
  }
}


// WEBPACK FOOTER //
// ./src/utils/fetcher.ts